import { render, staticRenderFns } from "./BookingOverview.vue?vue&type=template&id=edb1049a&scoped=true&"
import script from "./BookingOverview.vue?vue&type=script&lang=js&"
export * from "./BookingOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb1049a",
  null
  
)

export default component.exports